import { useContext } from "react";

import CheckoutItem from "../../components/checkout-item/checkout-item.component";

import { CartContext } from "../../contexts/cart.context";

import { Block, CheckoutContainer, Header, Total } from "./checkout.styles";

const Checkout = () => {
  const { cartItems, totalCartPrice } = useContext(CartContext);

  return (
    <CheckoutContainer>
      <Header>
        <Block>
          <span>Product</span>
        </Block>
        <Block>
          <span>Description</span>
        </Block>
        <Block>
          <span>Quantity</span>
        </Block>
        <Block>
          <span>Price</span>
        </Block>
        <Block>
          <span>Remove</span>
        </Block>
      </Header>
      {cartItems.map((ci) => (
        <CheckoutItem key={ci.id} cartItem={ci} />
      ))}
      <Total>Total: ${totalCartPrice}</Total>
    </CheckoutContainer>
  );
};

export default Checkout;
